import { BREAKPOINT_L, BREAKPOINT_M, BREAKPOINT_S, BREAKPOINT_XL } from '@audi/audi-ui-design-tokens';
import { useEffect, useState } from 'react';
import { BreakPoints, mobileBreakPoint } from '~/styles/break-points';

export const useBreakPoint = (customBreakPoint?: keyof BreakPoints | typeof mobileBreakPoint) => {
	const [isMobile, setIsMobile] = useState('ontouchstart' in window);
	const [isMobileView, setIsMobileView] = useState(window.innerWidth < mobileBreakPoint);
	const [isXlBreakpoint, setIsXlBreakpoint] = useState(window.innerWidth < BREAKPOINT_XL);
	const [isLBreakpoint, setIsLBreakpoint] = useState(window.innerWidth < BREAKPOINT_L);
	const [isMBreakpoint, setIsMBreakpoint] = useState(window.innerWidth < BREAKPOINT_M);
	const [isSBreakpoint, setIsSBreakpoint] = useState(window.innerWidth < BREAKPOINT_S);
	const [isCustomBreakpoint, setIsCustomBreakPoint] = useState(
		window.matchMedia(`(min-width: ${customBreakPoint}px)`).matches,
	);

	const update = () => {
		setIsMobile('ontouchstart' in window);
		setIsMobileView(window.innerWidth < mobileBreakPoint);
		setIsXlBreakpoint(window.innerWidth < BREAKPOINT_XL);
		setIsLBreakpoint(window.innerWidth < BREAKPOINT_L);
		setIsMBreakpoint(window.innerWidth < BREAKPOINT_M);
		setIsSBreakpoint(window.innerWidth < BREAKPOINT_S);
		setIsCustomBreakPoint(window.matchMedia(`(min-width: ${customBreakPoint}px)`).matches);
	};

	useEffect(() => {
		window.addEventListener('resize', update);
		return () => window.removeEventListener('resize', update);
	}, [customBreakPoint]);

	return {
		isMobile,
		isMobileView,
		isXlBreakpoint,
		isLBreakpoint,
		isMBreakpoint,
		isSBreakpoint,
		isCustomBreakpoint,
	};
};
